import { COMMON_PROPS } from '@/trendData/baseItem.constants';
import { ITEM_DATA_STATUS } from '@/trendData/trendData.constants';
import type { BaseItemState } from '@/trendData/itemStoreBase.types';

export const baseItemInitialState: BaseItemState = { ...COMMON_PROPS };

/** Data statuses that clear an item's `data` when set, so stale data is not left on display. */
export const TERMINAL_STATUSES = [
  ITEM_DATA_STATUS.FAILURE,
  ITEM_DATA_STATUS.NOT_REQUIRED,
  ITEM_DATA_STATUS.REDACTED,
  ITEM_DATA_STATUS.HIDDEN_FROM_TREND,
  ITEM_DATA_STATUS.ABORTED,
];
